import check from './check'
import login from './login'
import logout from './logout'
import register from './register'
import resendEmail from './resend-email-confirm'
import confirmEmail from './confirm-email'
import requestResetPassword from './request-reset-password'
import resetPassword from './reset-password'
import upgradeAccount from './upgrade-account'
import fetchTrial from './fetch-trial'
import getOtp from './get-otp'
import checkOtp from './check-otp'
import resendSmsOtp from './resend-sms-otp'
import verifySmsOtp from './verify-sms-otp'

export default {
  check,
  login,
  logout,
  register,
  resendEmail,
  confirmEmail,
  requestResetPassword,
  resetPassword,
  upgradeAccount,
  fetchTrial,
  getOtp,
  checkOtp,
  resendSmsOtp,
  verifySmsOtp
}



// WEBPACK FOOTER //
// ./src/services/auth/index.js